module.exports = __webpack_public_path__ + "img/ChSimplified-T200.d10116c3.gif";